module.exports = __webpack_public_path__ + "img/em_mockup_03.72aa4947.png";